import React from 'react'

export default function CloseButtonStyle(props) {
  const { options } = props
  return(
    <React.Fragment>
      <style jsx='true'>
      {`
        .close-button {
          border-radius: 50%;
          background-color: rgba(255, 0, 0, 1);
          color: whitesmoke;
          width: 25px;
          height: 25px;
          border: none;
          transform: scale(${options.scale});
        }
        .close-button:hover, close-button:focus {
          background-color: rgba(200, 0, 0, 1);
          color: white;
        }
        .close-button:disabled {
          background-color: lightgrey;
          color: darkgrey;
        }
      `}
      </style>
    </React.Fragment>
  )
}
